import queryString from 'query-string';
import _ from 'lodash';
import { remapKeys } from '../../utils';

export const getPasswordReset = (state) => {
  return state.passwordReset;
};


export const getQueryString = (state) => {
  const { querySearch } = getPasswordReset(state);
  return querySearch;
};


export const getEphemeralCredentials = (state) => {
  const wireFields = ['client_id', 'token', 'uid'];
  const wireMap = {
    client_id: 'client',
    token: 'access-token',
    uid: 'uid',
  };

  const queryValue = getQueryString(state);
  const queryObject = queryString.parse(queryValue);
  const boundHas = _.partial(_.has, queryObject);
  const hasAllFields = _.every(wireFields, boundHas);

  if (!hasAllFields) {
    return null;
  }

  /*
  * NOTE: There is almost certainly a way to make this more readable with currying/partials
  * At the moment it is just easier to nest the calls.
   */
  const ephemeralCredentials = remapKeys(_.pick(queryObject, wireFields), wireMap);

  return ephemeralCredentials;
};


export const hasEphemeralCredentials = (state) => {
  const ephemeralCredentials = getEphemeralCredentials(state);
  if (ephemeralCredentials) {
    return true;
  }
  return false;
};
